import Account from './account';
import ApiGrants from './apigrants';
import BillingDetails from './billingdetails';
import Consent from './consent';
import Contacts from './contacts';
import Errors from './errors';
import Invoices from './invoices';
import Layout from './layout';
import Notification from './notification';
import Pending from './pending';
import Route from './route';
import Session from './session';
import Transfer from './transfer';
import Transfers from './transfers';
import TransfersReceived from './transfers-received';
import UI from './ui';
import UploadNotifications from './upload-notifications';
import User from './user';

export default {
  Contacts,
  Layout,
  Notification,
  Transfer,
  Session,
  Route,
  Transfers,
  TransfersReceived,
  User,
  Account,
  Pending,
  Errors,
  UI,
  Invoices,
  ApiGrants,
  BillingDetails,
  Consent,
  UploadNotifications,
};
